import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { StateService } from '../state.service';
import { NewsletterApi } from '../newsletter-api.service';
import { ResourceService } from '../resources.service';

@Component({
  selector: 'app-send-link',
  templateUrl: './send-link.component.html',
  styleUrls: ['./send-link.component.css']
})
export class SendLinkComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private stateService: StateService,
    private api: NewsletterApi,
    private r: ResourceService) { }

  ngOnInit() {
    if(!this.stateService.email)
      this.router.navigate(['/']);
  }

  send() {
    this.api.sendLink(this.stateService.email)
      .subscribe(res => this.router.navigate(['/link-sent']));
  }

}
